import { useLoaderData } from 'react-router';

import Loader from '@helsenorge/designsystem-react/components/Loader';
import Spacer from '@helsenorge/designsystem-react/components/Spacer';
import Title from '@helsenorge/designsystem-react/components/Title';

import { Breakpoint, useBreakpoint } from '@helsenorge/designsystem-react';
import { HNeventSetVisPersonvelger } from '@helsenorge/framework-utils/web-component/events';

import usePersonvelger from '../../hooks/usePersonvelger';
import PersonvelgerListe from '../personliste';
import { useRedirectContext } from '../redirect-provider/useRedirectContext';

const Personvelger: React.FC = () => {
  const { headerFooter, personvelgerStatusMessages, representasjonsforholdError } = useLoaderData();
  const {
    users,
    errors: { profileError },
    loading,
    hasSelectedUser,
    handleSelectUser,
  } = usePersonvelger();
  const { redirectToUrlAfterLogin, redirectTo } = useRedirectContext();
  const breakpoint = useBreakpoint();
  const smallSize = breakpoint === Breakpoint.xs;
  const handleRedirect = (newPersonHasBeenSelected: boolean): void => {
    if (redirectToUrlAfterLogin && redirectTo) {
      window.location.assign(redirectTo);
    } else if (!newPersonHasBeenSelected && redirectTo) {
      window.location.assign(redirectTo);
    } else if (!newPersonHasBeenSelected) {
      // Bruker har valgt samme person som er valgt fra før
      HNeventSetVisPersonvelger(false);
    } else {
      // Bruker har valgt å representere en ny person
      window.location.assign('/');
    }
  };

  const titleId = 'personvelger-title';

  return (
    <section aria-labelledby={titleId}>
      <Title htmlMarkup={'h1'} appearance={'title1'} margin={smallSize ? 1.5 : 2} id={titleId}>
        {headerFooter?.header.personvelger?.personvelgerHeader}
      </Title>

      {headerFooter?.header.personvelger && (
        <>
          <PersonvelgerListe
            messages={personvelgerStatusMessages}
            resources={headerFooter?.header.personvelger}
            users={users}
            onSelectUser={user => handleSelectUser(user, () => handleRedirect(!user.selected))}
            highlightUser={hasSelectedUser}
            errors={{
              profileError,
              representasjonsforholdError,
            }}
            id="personvelger-tjenester"
          >
            {loading && <Loader center />}
          </PersonvelgerListe>
          <Spacer size={smallSize ? 'xs' : 'l'} />
        </>
      )}

      <p>{headerFooter?.header.personvelger?.personvelgerIngress}</p>
    </section>
  );
};

export default Personvelger;
